var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({staticClass:"form-field",attrs:{"type":"text"},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }